<template>
  <div class="question-builder-latex">
    <div class="left-right">
      <div class="left">
        <div class="yo-topic-title">
          <h1>
            Question Builder
          </h1>
          <h2>
            <a class="el-button" @click="goBack()">Go Back</a>
          </h2>
        </div>
        <div>
          <p>Question Title: {{ dbObject.title }}</p>
        </div>
        <div class="yo-content-block">
          <h2>Question:</h2>
          <LatexEdit ref="latexedit" :placeholder="`Please Type your Question here in latex format....`" :init="question.latex" @view="(v) => { saveTo = { obj: question, key: 'latex' }; view = v;  }" @text="setQuestionText"></LatexEdit>
        </div>

        <AnsTypeChooser @save="save" :question="question"></AnsTypeChooser>
        <AnsEdit @view="(v) => { view = v;  }" @saveTo="(v) => { saveTo = v }" @save="save" :question="question"></AnsEdit>
        <h2>
          <a class="el-button" @click="goBack()">Finished, Go Back</a>
        </h2>
      </div>
      <div class="right">
        <div class="saving">
          <strong class="saved" v-if="saving === 'saved'">Data Saved to Cloud....</strong>
          <strong class="saving-ing" v-if="saving === 'saving'">Saving Data to Cloud... Dont Close....</strong>
        </div>
        <PhoneBox class="phone" ref="phone">
          <ContentDisplay @saveTo="(v) => { saveTo = v }" @view="(v) => { view = v }" :question="question">
          </ContentDisplay>
        </PhoneBox>
      </div>
    </div>
    <div class="clearfloat"></div>

    <div v-if="view === 'myscript'" class="overlay">
      <MyScript @done="(v) => { myScriptDone({ value: v.latex }) }" @view="(v) => { view = v; }" />
    </div>
    <div v-if="view === 'photogallery'" class="overlay">
      <PhotoGallery :mode="'pick'" @view="(v) => { view = v }" @imgsrc="(v) => { $emit('done-image-pick', { value: v, saveTo }) }" />
    </div>
  </div>
</template>

<script>
import * as QS from '../yoqb-compos/question.js'
export default {
  components: {
    AnsTypeChooser: require('../yoqb-compos/AnsTypeChooser.vue').default,
    AnsEdit: require('../yoqb-compos/AnsEdit.vue').default,
    PhotoGallery: require('./PhotoGallery.vue').default,
    ContentDisplay: require('../yoqb-compos/ContentDisplay.vue').default,
    MyScript: require('../yoqb-compos/MyScript.vue').default,
    PhoneBox: require('../yoqb-compos/PhoneBox.vue').default,
    LatexEdit: require('../yoqb-compos/LatexEdit.vue').default
  },
  props: {
    saving: {
      required: true
    },
    dbObject: {
      required: true
    },
    question: {
      required: true,
      default () {
        return QS.makeSampleQuestion()
      }
    }
  },
  data() {
    return {
      needsToSave: false,
      drawboardReady: false,
      saveTo: { obj: this.question, key: 'latex' },
      left: false,
      view: 'main'
    }
  },
  beforeDestroy () {
    this.left = true
    clearInterval(this.checker)
  },
  created () {
    this.onMount()
  },
  mounted() {
    this.onAutoSave()

    // require('../compos/MyScript.vue').default.preload()
    this.left = false

    this.question.latex += ' '
    this.$nextTick(() => {
      this.question.latex = this.question.latex.slice(0, this.question.latex.length - 1)
    })
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    onAutoSave () {
      let qq = JSON.parse(JSON.stringify(this.question))
      qq = QS.attachQuestionOnlyData(qq)
      let existingJSON = JSON.stringify(qq)
      this.checker = setInterval(() => {
        qq = JSON.parse(JSON.stringify(this.question))
        qq = QS.attachQuestionOnlyData(qq)
        let now = JSON.stringify(qq)
        if (existingJSON !== now) {
          existingJSON = now
          this.$emit('save', JSON.parse(now))
        }
      }, 1000)
    },
    load() {
    },
    save() {
    },
    myScriptDone ({ value }) {
      if (this.left) { return }

      if (this.saveTo.operation === 'set') {
        this.saveTo.obj[this.saveTo.key] = `$$${(value + '').trim()}$$`
      } else {
        this.saveTo.obj[this.saveTo.key] += `$$${value}$$\n`
      }
    },
    onMount() {
      this.$on('done-image-pick', ({ value }) => {
        this.$nextTick(() => {
          if (this.left) { return }
          console.log(value, this.saveTo)
          const html = `<div class="yo-latex-image-center" style="display: flex; justify-content: center; flex-wrap: wrap;">
  <div class="yo-latex-image-wrap">
    <img class="yo-latex-image" src="${value || `https://via.placeholder.com/320x320`}" style="max-width: 100%;" />
  </div>
</div>`
          this.saveTo.obj[this.saveTo.key] = `${this.saveTo.obj[this.saveTo.key]}\n${html}`
        })
      })
    },
    toBottom() {
      if (this.$refs.latexedit) {
        this.$refs.latexedit.toBottom()
      }
      this.$nextTick(() => {
        if (this.$refs.phone) {
          this.$refs.phone.toBottom()
        }
      })
    },
    addImageToQuestion(link) {
      const html = `<div class="yo-latex-image-center" style="display: flex; justify-content: center; flex-wrap: wrap;">
  <div class="yo-latex-image-wrap">
    <img class="yo-latex-image" src="${link || `https://via.placeholder.com/320x320`}" style="max-width: 100%;" />
  </div>
</div>`
      this.question.latex = `${this.question.latex}\n${html}`
      this.toBottom()
    },
    setQuestionText(v) {
      this.question.latex = `${v}`
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

.question-builder-latex{
  margin: 20px;
}
.overlay{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  z-index: 1000000;
}

.left-right{
  display: flex;
}
.left{
  display: inline-block;
  max-width: 850px;
  width: 570px;
}
.right {
  display: inline-block;
  margin-left: 15px;
  min-width: 435px;
}
.phone{
  position: sticky;
  top: 50px;
}
.saving{
  position: sticky;
  top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.saved{
  color: green;
}
.saving-ing{
  color: orange;
}
</style>
